export { default } from './UsersSetRolesModal.action'



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Users/UsersSetRolesModal/index.js